import { createApp } from "vue";
import App from "./App.vue";
import Bootstrap from "./assets/scss/custom.scss";
import VueRouter from "vue-router";

import Router from "./router";
import Modal from "../src/components/Modal.vue";

import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "@fortawesome/fontawesome-free/css/all.css";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "vue-add-to-calendar";
import "add-to-calendar-button";

import vSelect from "vue-select";
import TheMask from "vue-the-mask";

import preventClick from "./directives/preventClick.js";

// Componentes como vue-select disparam vários resizes na mesma volta do
// event loop; sem o debounce via rAF, o navegador emite o aviso benigno
// "ResizeObserver loop completed with undelivered notifications." (não é
// um erro da aplicação, mas aparece como overlay em tela cheia no dev server).
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const options = {
  timeout: 5000,
  theme: "bubble",
  position: "bottom-right",
  duration: 5000,
  keepOnHover: true,
};

const app = createApp(App)
  .use(Bootstrap)
  .use(VueRouter)
  .use(Router)
  .use(FloatingVue)
  .use(Toast, options)
  .use(TheMask)
  .component("modal", Modal)
  .component("v-select", vSelect)
  .directive("prevent-click", preventClick);

app.config.globalProperties.formatPhone = function (phone) {
  let rawPhone = phone.slice(3); // Remove o +55
  rawPhone = rawPhone.replace(/\D/g, ""); // Remove tudo que não for número
  // Força o +55
  if (rawPhone.length <= 0) {
    phone = `+55 `;
  } else if (rawPhone.length <= 2) {
    phone = `+55 ${rawPhone}`;
  } else {
    phone = `+55 ${rawPhone.slice(0, 2)} ${rawPhone.slice(2, 11)}`;
  }
  return phone;
};

app.mount("#app");
